import React from 'react';
import NewsletterSubscribe from '../components/NewsletterSubscribe';
import NewsSubLeft from '../assets/images/newsletter-left.svg';
import NewsSubRight from '../assets/images/newsletter-right.svg';
import styled from 'styled-components';

const ImageWrapper = styled.div`
  width:10%;
  @media screen and (min-width:900px) {
    width:20%;
  }

`;
export default function NewsletterSubscribeSection({heading, bottomHeading, confirmation}) {
  return (
    <div className="bg-black text-white relative flex">
      <ImageWrapper className="hidden md:flex flex-col justify-end items-center">
        <img className="w-full" src={NewsSubLeft} alt="" style={{ maxWidth: '190px' }} />
      </ImageWrapper>

      <div className="flex-auto px-8 py-14 " style={{flex:'1 1 auto'}}>
        <h4 className="text-32px font-semibold text-center">{heading}</h4>
        <div className="max-w-md mx-auto my-5">
          <NewsletterSubscribe confirmation={confirmation} />
        </div>

        <div className="text-center" dangerouslySetInnerHTML={{__html:bottomHeading}} />
      </div>

      <ImageWrapper className="hidden md:flex flex-col justify-end">
        <img src={NewsSubRight} alt="" />
      </ImageWrapper>
    </div>
  );
}
